import { authenticate } from '~/lib/authenticate'
import { pagesPath } from '~/lib/$path'
import { SignUpPage } from '~/features/adv_account/SignUpPage'

export default authenticate(SignUpPage, ({ currentUser, currentUserAdv, currentAdv }) => ({
  redirects: [[pagesPath.home.$url().pathname, currentUser !== null && currentUserAdv !== null && currentAdv !== null]],
}))
